import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgCustomHeaderComponent } from 'src/app/shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { AgGridI, AgGridPaginationConfig } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridImportBOMMapErrors, AgGridImportCodecrosswalkErrors, AgGridImportCompaniesErrors } from "../errors-tab/errors-tab.model"
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { ImportDocumentsService } from '../../import-documents.service';
import { Subscription } from 'rxjs';
import { CommonTabService } from 'src/app/shared/services/common-tab.service';
import { Button, CurrentTab, LabelsName, RoutePath, TabNames } from 'src/app/shared/model/enum';
import { ToastrService } from 'ngx-toastr';
import { ImportCompanyCommand } from '../../import-documents.model';
import { ColDef } from 'ag-grid-community';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { ProgressHelperService } from '../step-progressbar/progress-helper.service';
import { AddCompanyService } from '../../../crm/companies/pop-ups/add-company/add-company.service';
import { RequirementsService } from '../../../sales/requirements/pages/requirements/requirements.service';


@Component({
  selector: 'app-errors-tab',
  templateUrl: './errors-tab.component.html',
  styleUrls: ['./errors-tab.component.scss']
})
export class ErrorsTabComponent implements OnInit {
  enumButtonName = Button;
  enumErrorFiledName = LabelsName;
  agGridPaginationConfig = new AgGridPaginationConfig();
  dataModel: AgGridI;
  isDuplicate = false
  defaultView = true
  isLoading: boolean = false;

  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    };
  rowData = [];
  flexHeight;
  columnList: any[] = []
  companyData = []
  sub: Subscription;
  importCompanyCommand = new ImportCompanyCommand();
  private gridApi;
  required = []
  codeCrosswalkList: any[] = []
  getAllRequirementDropdowns: any = {}
  sicValues: any[] = []
  isRecall: boolean = false;
  importError: boolean = false;
  potentialError: boolean = false;
  data: any
  public defaultColDef: ColDef = {
    resizable: true,
    //  maxWidth:250
  };
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  currentTab: string;
  isPreviewTabOpen: boolean = false;
  @ViewChild("prevCallButton") prevCallButton: ElementRef
  routeUrl: string;
  routePath = RoutePath;
  tabName = CurrentTab;
  importTabName = TabNames;
  actWidth: number = 0
  constructor(
    public commonTabService: CommonTabService,
    private router: Router,
    public commonService: CommonService,
    public toaster: ToastrService,
    public importDocumentsService: ImportDocumentsService,
    public tabsService: TabsService,
    public codeCrosswalkService: CodeCrosswalkService,
    public helperService: ProgressHelperService,
    public companiesService: AddCompanyService,
    public requirementsService: RequirementsService,
  ) {
    this.routeUrl = this.router.url;
    this.sub = this.importDocumentsService.dataPassAccordingToTrackingBar.subscribe(res => {
      if (res?.response?.moduleData) {
        this.data = res.response.moduleData;
        this.processErrorData();
      }
    })

  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  ngAfterViewInit() {
    // You can access the button element here      
  }


  fn() {
    if (this.data?.importError.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (this.data?.potentialCodeCrosswalk.length < 1) : (this.data?.potentialCompanies.length < 1))) {
      this.isDuplicate = true;
      this.potentialError = true;
      this.defaultView = false;
    } else if (this.data?.importError.length > 0) {
      this.defaultView = true;
      this.importError = false;
      this.filllist();
    } else {
      this.importError = true;
      this.filllist();
    }
    // this.errorMessage();
    //   if(this.columnList.length==0){
    //   this.importError = true;
    // }else{
    //   this.importError = false;
    //   this.filllist();
    // }

  }

  ngOnInit(): void {
    this.importDocumentsService.errorValidation.next(true);
    this.commonService.headerHeight.subscribe((res) => {
      this.flexHeight = "calc(100vh - 290px - " + res + "px" + ")";
    });
    this.helperService.actWidth.subscribe((res: any) => {
      this.actWidth = res;
    });
    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
      }
    })
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.dataModel = AgGridImportCodecrosswalkErrors;
    } else if (this.currentTab == this.tabName.IMPORT_BOM_TAB) {
      this.dataModel = AgGridImportBOMMapErrors;
    } else {
      this.dataModel = AgGridImportCompaniesErrors;
    }
    this.getCodeCrosswalkList();
    this.getAllRequirementDropdownList();

    // Fallback: process already-available data from BehaviorSubject
    // (in case the subscription fired before this component initialized)
    const existingData = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    if (existingData?.response?.moduleData && !this.data) {
      this.data = existingData.response.moduleData;
      this.processErrorData();
    }
  }
  errorMessage() {
    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    if (data?.response?.moduleData) {
      if (data?.response?.moduleData?.importError?.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (data?.response?.moduleData?.potentialCodeCrosswalk?.length < 1) : (this.currentTab == this.tabName.IMPORT_BOM_TAB ? (data?.response?.moduleData?.potentialImportBOM?.length < 1) : (data?.response?.moduleData?.potentialCompanies?.length < 1)))) {
        this.isDuplicate = true
        this.potentialError = true;
        this.defaultView = false;
        // this.importError = true;
      } else if (data?.response?.moduleData?.importError?.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (data?.response?.moduleData?.potentialCodeCrosswalk?.length > 0) : (this.currentTab == this.tabName.IMPORT_BOM_TAB ? (data?.response?.moduleData?.potentialImportBOM?.length > 0) : (data?.response?.moduleData?.potentialCompanies?.length > 0)))) {
        {
          this.isDuplicate = true
          this.potentialError = false;
          // this.importError = false;
        }
      } else {
        this.isDuplicate = false
        this.defaultView = false;
        this.isPreviewTabOpen = true;
        this.importDocumentsService.errorValidation.next(true);
      }
    }
  }

  processErrorData() {
    if (!this.data) return;
    if (this.currentTab == this.tabName.IMPORT_BOM_TAB) {
      let company = this.data?.data[0]?.company
      this.columnList = this.data?.importError
      this.columnList = this.columnList.map((x: any) => {
        return {
          ...x,
          companyName: company
        }
      })
      this.defaultView = true;
      this.importError = false;
      this.filllist();
    }
    else if (this.data?.importError.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (this.data?.potentialCodeCrosswalk.length < 1) : (this.data?.potentialCompanies.length < 1))) {
      this.isDuplicate = true;
      this.potentialError = true;
      this.defaultView = false;
    }
    else if (this.data?.importError.length > 0) {
      this.columnList = this.data?.importError
      this.defaultView = true;
      this.importError = false;
      this.filllist();
    } else {
      this.importError = true;
      this.filllist();
    }
  }

  filllist() {
    this.isLoading = true;
    this.rowData = this.columnList;
    let aa = this.commonTabService.getAllDropdownList.getValue()
    this.rowData.map((a) => {
      const field = a.errorField;
      switch (true) {
        case ['Sales Stage', 'Sale Stage', 'Stage'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().stageList.map(a => a.name);
          break;
        case ['Rating', 'rating'].includes(field):
          a.map = ['5', '4.5', '4', '3.5', '3', '2.5', '2', '1.5', '1', '0.5'];
          break;
        case ['Active', 'active'].includes(field):
          a.map = ['yes', 'no'];
          break;
        case ['Company State', 'Address State', 'State'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().stateList.map(a => a.name);
          break;
        case ['Company Type', 'Vendor Type', 'Type'].includes(field):
          if (this.currentTab == this.importTabName.IMPORT_VENDORS) {
            a.map = this.commonTabService.getAllDropdownList.getValue().vendorTypeList.map(a => a.name);
          } else {
            a.map = this.commonTabService.getAllDropdownList.getValue().typeList.map(a => a.name);
          }
          break;
        case ['Company Country', 'Address Country', 'Country', 'COO'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().countryList.map(a => a.name);
          break;
        case ['Salesperson', 'Sales Person'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().salesPersonList.map(a => a.name);
          break;
        case ['Alternate Salesperson', 'Alt Salesperson'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().altSalesPersonList.map(a => a.name);
          break;
        case ['Company Timezone', 'Contact Timezone', 'Timezone', 'Time Zone'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().timezoneList.map(a => a.name);
          break;
        case ['Tags', 'tags'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().tagsList.map(a => a.name);
          break;
        case ['Currency', 'currency'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().currencyList.map(a => a.name);
          break;
        case ['SIC Code', 'SIC'].includes(field):
          a.map = this.sicValues;
          break;
        case ['Buyer’s Rep', 'Buyers Rep', 'Buyer Rep'].includes(field):
          a.map = this.commonTabService.getAllDropdownList.getValue().buyerRepList.map(a => a.name);
          break;
        case ['Requirement Source', 'Req Source', 'Req. Source'].includes(field):
          a.map = this.getAllRequirementDropdowns.requirementSourceList.map(a => a.name);
          break;
        case ['Priority', 'priority'].includes(field):
          a.map = this.getAllRequirementDropdowns.priorityList.map(a => a.name);
          break;
        case ['MPN', 'mpn'].includes(field):
          a.map = this.getAllRequirementDropdowns.mpnList.map(a => a.name);
          break;
        case ['MFR', 'mfr'].includes(field):
          a.map = this.getAllRequirementDropdowns.masterManufacturerWithChildrenList.map(a => a.name);
          break;
        case ['Date Code Year'].includes(field):
          a.map = this.getAllRequirementDropdowns.dcCodeYearList.map(a => a.name);
          break;
        case ['Date Code Week'].includes(field):
          a.map = this.getAllRequirementDropdowns.dcCodeWeekList.map(a => a.name);
          break;
        case ['RoHS', 'rohs'].includes(field):
          a.map = this.getAllRequirementDropdowns.roHSList.map(a => a.name);
          break;
        case ['Condition', 'condition'].includes(field):
          a.map = this.getAllRequirementDropdowns.inventoryConditionsList.map(a => a.name);
          break;
        case ['Item Package', 'Item Pkg', 'Item Pkg.'].includes(field):
          a.map = this.getAllRequirementDropdowns.itemPackagingList.map(a => a.name);
          break;
        case ['Testing', 'testing'].includes(field):
          a.map = this.getAllRequirementDropdowns.testingList.map(a => a.name);
          break;
        case ['Opportunity Type'].includes(field):
          a.map = ['Buy', 'Bid'];
          break;
        case ['Project Approved'].includes(field):
          a.map = ['Yes', 'No'];
          break;
        case ['Category Group'].includes(field):
          a.map = this.getAllRequirementDropdowns.categoryGroupList.map(a => a.name);
          break;
        case ['Parent Category'].includes(field):
          a.map = this.getAllRequirementDropdowns.parentCategoryGroupList.map(a => a.name);
          break;
        case ['Category', 'Inventory Category'].includes(field):
          a.map = this.getAllRequirementDropdowns.inventoryCategoryList.map(a => a.name);
          break;
        case ['Sub Category', 'Sub-Category'].includes(field):
          a.map = this.getAllRequirementDropdowns.subCategoryList.map(a => a.name);
          break;
        case ['Part Status'].includes(field):
          a.map = this.getAllRequirementDropdowns.partStatusList.map(a => a.name);
          break;
        case ['Opportunity Buy Type'].includes(field):
          a.map = this.getAllRequirementDropdowns.opportunityBuyTypeList.map(a => a.name);
          break;
        default:

      }
      a.mappedColumn = '';
      a.status = a.status
    })
    this.gridApi.setRowData(this.rowData);
    if (this.rowData?.length > 0)
      this.isLoading = false;
  }

  onSelectionChanged($event) { }
  closeTab() {
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.importDocumentsService.closeVendorTab();
      this.router.navigate([this.routePath.VENDORLIST_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.VENDORLIST_TAB)
    } else if (this.currentTab == this.tabName.IMPORT_BOM_TAB) {
      this.importDocumentsService.closeBOMTab();
      this.router.navigate([this.routePath.REQUIREMENT_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.REQUIREMENTS_TAB)
    } else {
      this.importDocumentsService.closeTab();
      this.router.navigate([this.routePath.COMPANY_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.COMPANY_TAB)
    }
  }
  close() {
    this.codeCrosswalkService.valuePopup.next(true)
  }

  applyChanges() {
    // ===== TEMPORARY: Force failure for testing stepFail SVG & failed screen =====
    // Comment out or remove this block when done testing
    const fakeFailRes: any = { isSuccess: false, message: 'Forced test failure', response: null };
    this.importDocumentsService.applyChanges.next(fakeFailRes);  // → hasFailed = true (shows stepFail SVG on progress bar)
    this.importDocumentsService.toEnd.next(fakeFailRes);         // → failed = false (shows failure screen in summary-tab)
    this.toaster.error(fakeFailRes.message);
    return; // Skip the real API call
    // ===== END TEMPORARY =====

    // setTimeout(() => {
    //   this.importDocumentsService.applyChanges.next(true);
    // }, 1000);
    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    this.importCompanyCommand.companyData = data?.response?.moduleData?.companyData;
    this.importCompanyCommand.importError = data?.response?.moduleData?.importError;
    this.importCompanyCommand.duplicateCompanies = data?.response?.moduleData?.potentialCompanies;
    this.importCompanyCommand.templateId = data?.response?.moduleData?.templateId;
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.importCompanyCommand.isVendor = true;
    }
    this.importDocumentsService.insertImportOnlyCompany(this.importCompanyCommand).subscribe(res => {
      if (res.isSuccess) {
        this.importDocumentsService.applyChanges.next(res);
        this.importDocumentsService.toEnd.next(res);
        this.toaster.success(res.message);
      } else {
        this.toaster.error(res.message);
        this.importDocumentsService.applyChanges.next(res);
        this.importDocumentsService.toEnd.next(res);
      }
    })

  }
  isDisabled: boolean = false
  handleClick() {
    this.importDocumentsService.submit
    this.isDisabled = true;
    this.onNextClick()
    this.performAction().finally(() => {
      this.isDisabled = false;
    });
  }

  async performAction() {
    return new Promise((resolve) => setTimeout(resolve, 1000));

  }

  isDataLoading: boolean = false;
  onNextClick() {
    const allRows: any[] = [];
    this.gridApi.forEachNode((node: any) => allRows.push(node.data));
    for (let row of allRows) {
      if (row.errorField?.toLowerCase().includes('email')) {
        if (row.invalidEmail) {
          this.toaster.error('Please enter a valid email address with the pattern: user@example.com');
          return;
        }
      }
    }
    this.isDataLoading = true
    setTimeout(() => {
      this.duplicateCall(allRows)
    }, 100);
  }
  duplicateCall(errorRows:any[]) {
    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    data.response.moduleData.importError = errorRows;
    const importError = data?.response?.moduleData?.importError.some((x) => x.correctField === '');
    if (importError && !this.importError) {
      this.passDataToDetails();
    } else {
      this.defaultView = false;
      this.isDuplicate = true;

      if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
        if (data?.response?.moduleData?.potentialCodeCrosswalk?.length > 0) {
          this.potentialError = false;
        }
        if (data?.response?.moduleData?.potentialCodeCrosswalk?.length == 0) {
          this.potentialError = true;
          // this.applyChanges()
        }
      } else {
        if (data?.response?.moduleData?.potentialCompanies?.length > 0) {
          this.potentialError = false;
        }
        if (data?.response?.moduleData?.potentialCompanies?.length == 0) {
          this.potentialError = true;
          // this.applyChanges()
        }
      }

    }
    this.isDataLoading = false
  }


  passDataToDetails() {
    if (this.currentTab == this.tabName.IMPORT_BOM_TAB && this.importDocumentsService.submit) {
      this.isRecall = false;
      const list = [];
      this.gridApi.forEachNode((a) => {
        list.push(a.data)
      });
      list.map((b) => {
        if (b.correctField === b.company) {
          b.status = true
        }
      })
      list.map((a) => {
        if (this.required.includes(a.company)) {
          a.isRequired = true;
        } else {
          a.isRequired = false;
        }
      })
      this.importCompanyCommand.importError = list;
      this.importDocumentsService.dataPassAccordingToTrackingBar.next(this.importCompanyCommand);
    } else if (this.importDocumentsService.submitted) {
      this.isRecall = false;
      const list = [];
      this.gridApi.forEachNode((a) => {
        list.push(a.data)
      });
      list.map((b) => {
        if (b.correctField === b.companyName) {
          b.status = true
        }
      })
      list.map((a) => {
        if (this.required.includes(a.companyName)) {
          a.isRequired = true;
        } else {
          a.isRequired = false;
        }
      })
      this.importCompanyCommand.importError = list;
      this.importDocumentsService.dataPassAccordingToTrackingBar.next(this.importCompanyCommand);
    } else {
      this.importDocumentsService.errorValidation.next(false);
      this.toaster.error("please insert required field");
    }
  }

  reloadData(event) {
    if (this.data?.importError.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (this.data?.potentialCodeCrosswalk.length < 1) : (this.currentTab == this.tabName.IMPORT_BOM_TAB ? (this.data?.potentialImportBOM.length < 1) : (this.data?.potentialCompanies.length < 1)))) {
      this.prev();
      setTimeout(() => {
        this.isDuplicate = true;
        this.potentialError = true;
        this.defaultView = false;
      }, 500);
    } else {
      this.importError = this.columnList?.length == 0 ? true : false;
      this.defaultView = event;
      this.isDuplicate = !event
      this.potentialError = !event;
    }
    // if(this.columnList.length==0){
    //   this.importError = true;
    // }else{
    //   this.importError = false;
    // }
    // this.defaultView=event;
    // this.isDuplicate =!event
    // this.potentialError=!event;

    // this.importDocumentsService.errorValidation.next(true);
    // this.isDuplicate =!event
    // this.potentialError=!event;
  }

  prev() {
    if (this.data?.importError.length < 1 && (this.currentTab == this.tabName.CODECROSSWALK_TAB ? (this.data?.potentialCodeCrosswalk.length < 1) : (this.currentTab == this.tabName.IMPORT_BOM_TAB ? (this.data?.potentialImportBOM.length < 1) : (this.data?.potentialCompanies.length < 1)))) {
      this.defaultView = true;
      setTimeout(() => {
        this.prevCallButton?.nativeElement.click();
      }, 200);
      this.isDuplicate = false;
      this.importError = true;
    }
  }

  previousCall() {
    this.importDocumentsService.errorValidation.next(true);
  }
  getCodeCrosswalkList() {
    this.companiesService.GetCodeCrosswalkList().subscribe((res) => {
      if (res.isSuccess) {
        this.codeCrosswalkList = res?.response?.codeCrosswalkList;
        this.sicValues = this.codeCrosswalkList?.map(item => item.sic);
      }
    })
  }
  getAllRequirementDropdownList() {
    this.requirementsService.getAllRequirementDropdown().subscribe((res => {
      if (res.isSuccess) this.getAllRequirementDropdowns = res?.response;
    }))
  }
}
